export default function condensePairwiseAlignmentDifferences(referenceSeq, alignedSeq) {
  const overviewMinimapTrack = [];
  const referenceSeqSplit = referenceSeq.toLowerCase().split("");
  const alignedSeqSplit = alignedSeq.toLowerCase().split("");
  const seqLength = alignedSeq.length;
  const alignedSeqWithoutLeadingDashes = alignedSeq.replace(/^-+/g, "");
  const alignedSeqWithoutTrailingDashes = alignedSeq.replace(/-+$/g, "");
  const startIndex = seqLength - alignedSeqWithoutLeadingDashes.length;
  const endIndex = seqLength - (seqLength - alignedSeqWithoutTrailingDashes.length);
  for (let i = 0; i < referenceSeqSplit.length; i++) {
    if (i < startIndex || i >= endIndex) {
      overviewMinimapTrack.push("W");
    } else if (referenceSeqSplit[i] === alignedSeqSplit[i] && referenceSeqSplit[i] !== "-" && alignedSeqSplit[i] !== "-") {
      overviewMinimapTrack.push("G");
    } else if (referenceSeqSplit[i] !== alignedSeqSplit[i] && referenceSeqSplit[i] !== "-" && alignedSeqSplit[i] !== "-") {
      overviewMinimapTrack.push("R");
    } else if (alignedSeqSplit[i] === "-") {
      overviewMinimapTrack.push("R");
    } else if (referenceSeqSplit[i] === "-" && referenceSeqSplit[i - 1] !== "-" && i !== referenceSeqSplit.length - 1 && referenceSeqSplit[i + 1] === "-") {
      overviewMinimapTrack.push("R");
    } else if (referenceSeqSplit[i] === "-" && referenceSeqSplit[i - 1] !== "-" && i !== referenceSeqSplit.length - 1 && referenceSeqSplit[i + 1] !== "-") {
      overviewMinimapTrack.push("R");
      i++;
    } else if (i === referenceSeqSplit.length - 1 && referenceSeqSplit[i] === "-" && referenceSeqSplit[i - 1] === "-") {
      overviewMinimapTrack.splice(-2, 1);
    } else if (i === referenceSeqSplit.length - 1 && referenceSeqSplit[i] === "-" && referenceSeqSplit[i - 1] !== "-") {
      overviewMinimapTrack.pop();
      overviewMinimapTrack.push("R");
    } else if (referenceSeqSplit[i] === "-" && referenceSeqSplit[i - 1] === "-" && referenceSeqSplit[i + 1] !== "-") {
      i++;
    } else if (referenceSeqSplit[i] === "-" && referenceSeqSplit[i - 1] === "-") {
    } else {
      console.error("should not reach this step!");
    }
  }
  return overviewMinimapTrack.join("");
}
